// npm
import React from 'react'

export default function SignIn() {
  return <p>Please sign in</p>
}
